<template>
	<div class="form-group">
		<label :for="name" :class="{ error: errors.has(name) }">{{ placeholder }}</label>
		<select :name="name" :id="name" v-model="selected" v-validate="rules" :data-vv-as="placeholder" class="form-control" :class="{ loading: !options.length, error: errors.has(name) }">
			<option disabled value="">{{ placeholder }}</option>
			<optgroup v-for="group in options" :key="group.value" :label="group.label">
				<option v-for="option in group.options" :key="option.value" :value="option.value">{{ option.text }}</option>
			</optgroup>
		</select>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'options',
		'name',
		'placeholder',
		'rules'
	],
	computed: {
		selected: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputSelectGrouped.vue